import { Attachment } from '@app/application/sidebar-file-attachments/types'

export type OpenDrawer = 'left' | 'right' | 'none'

export enum LeftDrawerContent {
  Default = 'default',
}

export enum RightDrawerContent {
  AuditLog = 'audit-log',
  Communication = 'communication',
  FileAttachments = 'file-attachments',
}

export type FileAttachmentsDrawerState = {
  direction: 'right'
  content: RightDrawerContent.FileAttachments
  options: {
    textPropertyName: string
    updateAttachments: (
      attachments: Attachment[],
      deletedDocumentIds: number[],
      successCallback: (() => void) | null,
      errorCallback: (() => void) | null
    ) => void
  }
}

export type DrawerState =
  | {
      direction: 'left'
      content: LeftDrawerContent
    }
  | FileAttachmentsDrawerState
  | {
      direction: 'right'
      content: RightDrawerContent
    }
  | {
      direction: 'initial'
      content: ''
    }
  | {
      direction: 'none'
      content: 'default'
    }
